import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TagOptionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TagPaginatedOptionsFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type TagOptionsQuery = { tagOptions: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string } }> | null } };


export const TagOptionsDocument = /*#__PURE__*/ gql`
    query tagOptions($filters: TagPaginatedOptionsFilters, $sort: [SortType!], $after: String, $first: Float) {
  tagOptions(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

export function useTagOptionsQuery(options?: Omit<Urql.UseQueryArgs<TagOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TagOptionsQuery, TagOptionsQueryVariables>({ query: TagOptionsDocument, ...options });
};